import React, { useEffect, useState } from 'react';
import {
  Dialog,
  IconButton,
  Typography,
  Box,
  Button,
  useMediaQuery,
  Theme,
  FormControlLabel,
  Checkbox,
  Modal,
} from '@mui/material';
import Image from 'next/image';
import { MuiIconButton } from './IconButton';
import { getFileType } from '@/utils';

interface MediaPopupProps {
  open: boolean;
  isFeatured: any;
  index: any;
  onClose: () => void;
  handleFeaturedSelect: () => void;
  handleDeleteMedia: () => void;
  mediaSrc: any;
  isVideo?: boolean;
}

const MediaPopup: React.FC<MediaPopupProps> = ({
  open,
  index,
  handleDeleteMedia,
  isFeatured,
  onClose,
  mediaSrc,
  isVideo = false,
  handleFeaturedSelect,
}) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  const [thumbnail, Setthumbnail] = useState('');
  const [imagesrc, SetImageSrc] = useState('');
  const [isChecked, setIsChecked] = useState(isFeatured);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleDeleteClick = () => setConfirmOpen(true);
  const handleCloseConfirm = () => setConfirmOpen(false);
  const handleConfirmDelete = () => {
    setConfirmOpen(false);
    handleDeleteMedia();
    onClose();
  };
  useEffect(() => {
    if (mediaSrc?.media) {
      if (mediaSrc?.media?.url && getFileType(mediaSrc?.media?.url) == 'image') {
        const newSrc = mediaSrc?.media?.url;
        SetImageSrc(newSrc);
      } else if (mediaSrc?.media?.file) {
        if (mediaSrc?.media?.preview) {
          SetImageSrc(mediaSrc?.media?.preview);
        }
      } else {
      }
    }
  }, [mediaSrc]);

  useEffect(() => {
    setIsChecked(isFeatured);
  }, [isFeatured]);

  useEffect(() => {
    if (mediaSrc?.media?.url && getFileType(mediaSrc?.media?.url) == 'video') {
      const generateThumbnail = async () => {
        if (isVideo && mediaSrc?.media?.url) {
          const thumb = mediaSrc.media.url;
          Setthumbnail(thumb);
        }
      };
      generateThumbnail();
    }
  }, [mediaSrc, isVideo]);
  return (
    <>
      {/* Main Media Popup */}
      <Modal
        open={open}
        onClose={onClose}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }}>
        <Box
          sx={{
            width: '400px',
            borderRadius: '12px',
            background: 'rgba(33, 45, 109, 0.7)',
            color: 'white',
            overflow: 'hidden',
            maxWidth: '100%',
            maxHeight: '100%',
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            '@media (max-width:600px)': {
              width: '100%',
              height: '100%',
              margin: 0,
              borderRadius: 0,
            },
          }}>
          {/* Close Button and Checkbox Section */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: 2 }}>
            <IconButton onClick={onClose} sx={{ color: 'white' }}>
              <Image priority src='/icons/close.svg' alt='close' width={15} height={15} />
            </IconButton>
            {!isVideo && (
              <Box sx={{ mt: '-5px' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        color: 'white',
                      }}
                      checked={isChecked}
                      onChange={() => {
                        setIsChecked((prev: any) => !prev);
                        handleFeaturedSelect();
                      }}
                    />
                  }
                  label='Featured'
                  labelPlacement='start'
                />
              </Box>
            )}
          </Box>

          {/* Media Content */}
          <Box sx={{ padding: 0, textAlign: 'center', flex: 1 }}>
            {isVideo ? (
              <video src={thumbnail} controls width='90%' style={{ borderRadius: '12px' }} />
            ) : (
              <Image priority
                src={imagesrc}
                alt='Media'
                width={!isMobile ? 375 : 300}
                height={500}
                layout='intrinsic'
                style={{
                  borderRadius: '12px',
                  maxWidth: '100%',
                  maxHeight: '100%',
                }}
              />
            )}
            <MuiIconButton
              icon='/icons/tick'
              label='Save'
              altIcon='Memvy'
              iconPosition='left'
              direction='row'
              background='rgba(33, 45, 109, 1)'
              width={!isMobile ? '353px' : '300px'}
              isRounded={false}
              height={!isMobile ? '58px' : '100%'}
              iconHeight={20}
              iconWidth={20}
              sx={{
                marginTop: '10px',
                borderRadius: '10px',
              }}
              method={onClose}
            />
            <MuiIconButton
              icon='/icons/delete-white'
              label='Delete Media'
              altIcon='Delete'
              iconPosition='left'
              iconHeight={20}
              iconWidth={20}
              direction='row'
              width={!isMobile ? '353px' : '300px'}
              isRounded={false}
              height={!isMobile ? '58px' : '100%'}
              sx={{
                color: '#ffffff',
                textTransform: 'none',
                display: 'flex',
                borderRadius: 0,
                alignItems: 'center',
                justifyContent: 'center',
              }}
              method={handleDeleteClick}
            />
          </Box>
        </Box>
      </Modal>
      {/* Delete Confirmation Popup */}
      <Dialog
        open={confirmOpen}
        onClose={handleCloseConfirm}
        maxWidth='xs'
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            width: '320px',
            height: '280px',
            borderRadius: '12px',
            background: 'rgba(241, 247, 250, 1)',
            color: 'white',
            textAlign: 'center',
          },
        }}>
        <Typography
          pl={'18px'}
          pr={'18px'}
          fontFamily={'DM Sans'}
          fontSize={'20px'}
          fontWeight={400}
          variant='h6'
          sx={{
            marginTop: '36px',
            marginBottom: '5px',
            color: '#000',
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
          }}>
          Are you sure you want to discard this media?
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', padding: 2, gap: 1 }}>
          <Button
            variant='contained'
            onClick={handleConfirmDelete}
            fullWidth
            sx={{
              height: '58px',
              fontSize: '1rem',
              backgroundColor: 'rgba(33, 45, 109, 1)',
              color: '#fff',
              borderRadius: '10px',
            }}>
            <Image priority src='/icons/tick.svg' alt='Save Icon' width={15} height={12} style={{ marginRight: '5px' }} />
            Yes, discard & delete.
          </Button>

          <Button
            variant='contained'
            fullWidth
            onClick={handleCloseConfirm}
            sx={{
              height: '58px',
              backgroundColor: 'rgba(33, 45, 109, 1)',
              color: '#fff',
              fontSize: '1rem',
              borderRadius: '10px',
            }}>
            No, keep editing
          </Button>
        </Box>
      </Dialog>
    </>
  );
};

export default MediaPopup;
